import { useState } from "react";

import { setOrganisationOfficerBranch } from "../api/officers";

/**
 * The branch an organisation officer works at. An admin can set or clear it
 * (the join form promises "your administrator can assign one later"); a
 * branch's own login stays with its branch; everyone else reads it.
 * `branches`: the organisation's branches (admin list); only active ones can
 * be chosen.
 */
export function OfficerBranchSelect({
  officer,
  branches,
  canChange,
  onChanged,
}) {
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  if (officer.isBranchLogin) {
    return (
      <span className="text-xs text-slate-500">
        Login of {officer.branch?.name}
      </span>
    );
  }
  if (!canChange) {
    return (
      <span className="text-xs text-slate-500">
        {officer.branch?.name ?? "No branch"}
      </span>
    );
  }

  const choices = (branches ?? []).filter(
    (branch) => branch.isActive || branch.id === officer.branch?.id,
  );

  async function change(event) {
    const branchId = event.target.value || null;
    setSaving(true);
    setError(null);
    try {
      onChanged(await setOrganisationOfficerBranch(officer.id, branchId));
    } catch (err) {
      setError(err.message ?? "The branch couldn't be changed.");
    } finally {
      setSaving(false);
    }
  }

  return (
    <span className="inline-flex flex-col gap-1">
      <select
        aria-label={`Branch of ${officer.fullName || "this officer"}`}
        value={officer.branch?.id ?? ""}
        onChange={change}
        disabled={saving}
        className="text-xs rounded border border-slate-300 bg-white px-2 py-1 text-slate-700 disabled:opacity-50"
      >
        <option value="">No branch</option>
        {choices.map((branch) => (
          <option key={branch.id} value={branch.id} disabled={!branch.isActive}>
            {branch.isActive ? branch.name : `${branch.name} (inactive)`}
          </option>
        ))}
      </select>
      {error ? <span className="text-xs text-red-600">{error}</span> : null}
    </span>
  );
}
